module.exports = __webpack_public_path__ + "static/media/rotaryDraw_bg1.27b70628.png";